import { getStore } from "app/store/store"
import { deepCopy, deepEquals } from "app/tools/common"
import { uiActionCreator } from "ui/store/actions"
import { IUIConfiguration } from "../model"

export const setUiConfigUndoRedoState = (uiConfig: IUIConfiguration, history: IUIConfiguration[], index: number) =>
  getStore().dispatch(uiActionCreator.setUiConfigUndoRedoState(uiConfig, history, index))

export const setTempUiConfigUndoRedo = (newConfig: IUIConfiguration) => {
  const { uiConfigUndoRedoHistory, uiConfigUndoRedoIndex } = getStore().getState().ui
  setUiConfigUndoRedoState(
    newConfig,
    [...uiConfigUndoRedoHistory.splice(0, uiConfigUndoRedoIndex + 1), newConfig],
    uiConfigUndoRedoIndex + 1
  )
}

export const undoUiConfigChange = () => {
  const { uiConfigUndoRedoHistory, uiConfigUndoRedoIndex } = getStore().getState().ui
  if (uiConfigUndoRedoIndex === 0 || uiConfigUndoRedoHistory.length === 1) {
    return
  }
  setUiConfigUndoRedoState(
    uiConfigUndoRedoHistory[uiConfigUndoRedoIndex - 1],
    uiConfigUndoRedoHistory,
    uiConfigUndoRedoIndex - 1
  )
}

export const redoUiConfigChange = () => {
  const { uiConfigUndoRedoHistory, uiConfigUndoRedoIndex } = getStore().getState().ui
  if (uiConfigUndoRedoIndex + 1 === uiConfigUndoRedoHistory.length) {
    return
  }
  setUiConfigUndoRedoState(
    uiConfigUndoRedoHistory[uiConfigUndoRedoIndex + 1],
    uiConfigUndoRedoHistory,
    uiConfigUndoRedoIndex + 1
  )
}

export const resetUiConfigChanges = (config?: IUIConfiguration) => {
  if (!config) {
    config = getStore().getState().ui.config
  }
  const newConfig = deepCopy(config)
  setUiConfigUndoRedoState(newConfig, [newConfig], 0)
}

export const hasUiConfigurationChanges = () => !deepEquals(getStore().getState().ui.config, getStore().getState().ui.tempConfig)

export const canUndoUiConfigChange = () => getStore().getState().ui.uiConfigUndoRedoIndex > 0

export const canRedoUiConfigChange = () =>
  getStore().getState().ui.uiConfigUndoRedoIndex < getStore().getState().ui.uiConfigUndoRedoHistory.length - 1
